import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7706d48d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-registration-container" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "publish-date-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Publish Date", -1))
const _hoisted_6 = { class: "data-table-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_family icon-a-buttonadd-icon" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("省内空白")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("大区内空白")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_family icon-delete1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Del ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_family icon-tianjia11" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Add ")
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Title = _resolveComponent("Title")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_bu_selector = _resolveComponent("bu-selector")!
  const _component_applicable_type_class_selector = _resolveComponent("applicable-type-class-selector")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_publish_date = _resolveComponent("publish-date")!
  const _component_focus_area_special_rule = _resolveComponent("focus-area-special-rule")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { dataSource: [{ name: 'Focus Area Rule Set' }] })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Title, {
          class: "title",
          text: "Focus area rule set"
        }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "publish-date-wrapper",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowPublishDateDrawer && _ctx.handleShowPublishDateDrawer(...args)))
          }, [
            _createVNode(_component_a_date_picker, {
              open: false,
              value: 
                            _ctx.publishDateVersion
                                ? _ctx.moment(_ctx.publishDateVersion)
                                : null
                        
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_table, {
            class: "data-table",
            columns: _ctx.columns,
            "data-source": _ctx.data,
            pagination: false,
            rowKey: (record, index) => index
          }, {
            BU: _withCtx(({ record }) => [
              _createVNode(_component_bu_selector, {
                value: record.bu,
                "onUpdate:value": ($event: any) => ((record.bu) = $event),
                disabled: _ctx.mode === _ctx.Mode.VIEW
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ]),
            ApplicableTypeClass: _withCtx(({ record }) => [
              _createVNode(_component_applicable_type_class_selector, {
                bu: record.bu,
                value: record.applicableTypeClass,
                "onUpdate:value": ($event: any) => ((record.applicableTypeClass) = $event),
                disabled: _ctx.mode === _ctx.Mode.VIEW
              }, null, 8, ["bu", "value", "onUpdate:value", "disabled"])
            ]),
            FocusAreaBasicRule: _withCtx(({ record }) => [
              _createVNode(_component_a_input, {
                value: "经销商所在城市",
                disabled: ""
              }),
              _hoisted_7,
              _createVNode(_component_a_select, {
                value: record.focusAreaExtend,
                "onUpdate:value": ($event: any) => ((record.focusAreaExtend) = $event),
                disabled: _ctx.mode === _ctx.Mode.VIEW
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "0" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "disabled"])
            ]),
            FocusAreaSpecialRule: _withCtx(({ index }) => [
              _createVNode(_component_a_input, {
                value: "-",
                onClick: ($event: any) => (_ctx.handleShowFocusAreaRuleSetDrawer(index))
              }, null, 8, ["onClick"])
            ]),
            Category: _withCtx(({ record }) => [
              _createVNode(_component_a_select, {
                value: record.category,
                "onUpdate:value": ($event: any) => ((record.category) = $event),
                disabled: _ctx.mode === _ctx.Mode.VIEW
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: category.id,
                      key: category.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "disabled"])
            ]),
            Operation: _withCtx(({ index }) => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "del-btn",
                onClick: ($event: any) => (_ctx.handleDelete(index))
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["columns", "data-source", "rowKey"]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            class: "add-btn",
            onClick: _ctx.handleAdd
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.mode === _ctx.Mode.EDIT]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_button, {
            class: "m-r-16",
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleSave
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 512), [
          [_vShow, _ctx.mode === _ctx.Mode.EDIT]
        ])
      ])
    ]),
    _createVNode(_component_publish_date, {
      "publish-date-version": _ctx.publishDateVersion,
      "onUpdate:publish-date-version": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.publishDateVersion) = $event)),
      "publish-date-versions": _ctx.publishDateVersions,
      "onUpdate:publish-date-versions": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.publishDateVersions) = $event)),
      visible: _ctx.visiblePublishDateDrawer,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visiblePublishDateDrawer) = $event))
    }, null, 8, ["publish-date-version", "publish-date-versions", "visible"]),
    _createVNode(_component_focus_area_special_rule, {
      visible: _ctx.visibleFocusAreaRuleSetDrawer,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visibleFocusAreaRuleSetDrawer) = $event)),
      "logic-id": _ctx.data?.[_ctx.selectedIndex]?.id ?? 0,
      "special-rule": _ctx.data?.[_ctx.selectedIndex]?.specialRule ?? [],
      onConfirm: _ctx.handleSubmitSpecialRule
    }, null, 8, ["visible", "logic-id", "special-rule", "onConfirm"])
  ], 64))
}